import { Flex, Text, HStack, Box, useClipboard, useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { LinkedinShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { Link } from './Link';
import LinkedIn from './LinkedIn';
import Facebook from './Facebook';
import Twitter from './Twitter';
import WhatsApp from './WhatsApp';

export const Share = ({
	linkedInUrl,
	facebookUrl,
	twitterUrl,
	copyUrl,
	title,
	hashtag,
	screen_name,
	gtmEvents,
}: {
	linkedInUrl: string;
	facebookUrl: string;
	twitterUrl: string;
	copyUrl?: string;
	hashtag?: string;
	title: string;
	screen_name: string;
	gtmEvents?: {
		[key: string]: string;
	};
}) => {
	const { hasCopied, onCopy } = useClipboard(copyUrl ? copyUrl : '');

	const [toastText, setToastText] = useState('');
	const toast = useToast();
	// clever tap
	const onShareTrack = (btnText: string, sequence: number) => {
		const gtm_event = gtmEvents ? gtmEvents[btnText] : '';
		// sendTrackingEvent({
		// 	event: gtm_event,
		// 	eventLabel: location.pathname,
		// });
	};
	useEffect(() => {
		if (hasCopied)
			toast({
				position: 'top',
				isClosable: true,
				render: () => (
					<Flex width={'140px'} height={'48px'} borderRadius={'ms-8'} justifyContent={'center'} color="white" p={3} mx="auto" bg="ms-red.900">
						{toastText}
					</Flex>
				),
			});
	}, [hasCopied]);
	return (
		<Flex p="16px" w="full" rounded="8px" bg="white" flexDir={'column'}>
			<Text textStyle={{ base: 'h6', md: 'h6' }}>Share</Text>
			<HStack justifyContent="space-between" spacing={'26px'} mt="24px" justify={'center'}>
				<WhatsappShareButton title={title + '\n'} url={twitterUrl} onClick={() => onShareTrack('twitter', 3)}>
					<Box w="48px" h="48px" rounded="100px" border="1px solid #E5E5E5" display="flex" alignItems="center" justifyContent="center" mx="auto">
						<WhatsApp boxSize="24px" />
					</Box>
					<Text textStyle="body2" color="#0A0103">
						Whatsapp
					</Text>
				</WhatsappShareButton>
				<FacebookShareButton url={facebookUrl} hashtag={hashtag} onClick={() => onShareTrack('facebook', 2)}>
					<Box w="48px" h="48px" rounded="100px" border="1px solid #E5E5E5" display="flex" alignItems="center" justifyContent="center" mx="auto">
						<Facebook boxSize="24px" />
					</Box>
					<Text textStyle="body2" color="#0A0103">
						Facebook
					</Text>
				</FacebookShareButton>
				<TwitterShareButton title={title + '\n'} url={twitterUrl} onClick={() => onShareTrack('twitter', 3)}>
					<Box w="48px" h="48px" rounded="100px" border="1px solid #E5E5E5" display="flex" alignItems="center" justifyContent="center" mx="auto">
						<Twitter boxSize="24px" />
					</Box>
					<Text textStyle="body2" color="#0A0103">
						Twitter
					</Text>
				</TwitterShareButton>
				<LinkedinShareButton url={linkedInUrl} onClick={() => onShareTrack('linkedin', 1)}>
					<Box w="48px" h="48px" rounded="100px" border="1px solid #E5E5E5" display="flex" alignItems="center" justifyContent="center" mx="auto">
						<LinkedIn boxSize="24px" />
					</Box>
					<Text textStyle="body2" color="#0A0103">
						Linkedin
					</Text>
				</LinkedinShareButton>
				{copyUrl && (
					<Box
						onClick={() => {
							setToastText('Link Copied!');
							onCopy();
							onShareTrack('copyUrl', 4);
						}}
						cursor={'pointer'}
					>
						<Link boxSize="6" />
					</Box>
				)}
			</HStack>
		</Flex>
	);
};
